import { render, staticRenderFns } from "./screen.vue?vue&type=template&id=1635a5d3&scoped=true"
import script from "./screen.vue?vue&type=script&lang=js"
export * from "./screen.vue?vue&type=script&lang=js"
import style0 from "./screen.vue?vue&type=style&index=0&id=1635a5d3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1635a5d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1635a5d3')) {
      api.createRecord('1635a5d3', component.options)
    } else {
      api.reload('1635a5d3', component.options)
    }
    module.hot.accept("./screen.vue?vue&type=template&id=1635a5d3&scoped=true", function () {
      api.rerender('1635a5d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/components/screen.vue"
export default component.exports